export default "__VITE_ASSET__DnxEfLqD__"